module.exports = __webpack_public_path__ + "img/tablet.12895f86.svg";